import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { VehicleColorTypeEnum } from '@splitsecondconnect/ultramarine-shared';

import { BaseSectionComponent } from 'app/shared/base-classes/sections/base-section.component';

import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { VehicleRecordModel } from '../../../models/vehicle-record.model';

import { ColorSaerchableComponent } from './components/color-searchable.component';

@Component({
	selector: 'app-vehicles-color',
	templateUrl: 'vehicles-color.component.html',
	imports: [
		ReactiveFormsModule,
		SectionWrapperComponent,
		ColorSaerchableComponent,
	],
})
export class VehiclesColorComponent extends BaseSectionComponent<VehicleRecordModel> {
	protected _skipCount: number = 0;
	exteriorColorType = VehicleColorTypeEnum.EXTERIOR;
	interiorColorType = VehicleColorTypeEnum.INTERIOR;
	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			exteriorColorId: [null],
			interiorColorId: [null],
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			exteriorColorId: this.recordData().exteriorColorId,
			interiorColorId: this.recordData().interiorColorId,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	protected _mapFormToModel(): Partial<VehicleRecordModel> {
		return {
			exteriorColorId: this.detailsForm.value.exteriorColorId,
			interiorColorId: this.detailsForm.value.interiorColorId,
		};
	}
}
